export const mockSystems = [
  {
    id: 'bonzo',
    name: 'Bonzo',
    color: 'bg-orange-500',
    text: 'text-orange-500',
    border: 'border-orange-500',
  },
  {
    id: 'ghl',
    name: 'GHL',
    color: 'bg-teal-500',
    text: 'text-teal-500',
    border: 'border-teal-500',
  },
  {
    id: 'five9',
    name: 'Five9',
    color: 'bg-violet-500',
    text: 'text-violet-500',
    border: 'border-violet-500',
  },
  {
    id: 'salesforce',
    name: 'Salesforce',
    color: 'bg-sky-500',
    text: 'text-sky-500',
    border: 'border-sky-500',
  },
]

export const generateTimeSeriesData = (
  points: number,
  base: number,
  variance: number,
) => {
  return Array.from({ length: points }).map((_, i) => ({
    time: `${i}:00`,
    value: Math.max(
      0,
      Math.floor(base + (Math.random() * variance * 2 - variance)),
    ),
    bonzo: Math.max(
      0,
      Math.floor(base * 0.4 + (Math.random() * variance - variance / 2)),
    ),
    ghl: Math.max(
      0,
      Math.floor(base * 0.3 + (Math.random() * variance - variance / 2)),
    ),
    five9: Math.max(
      0,
      Math.floor(base * 0.2 + (Math.random() * variance - variance / 2)),
    ),
    salesforce: Math.max(
      0,
      Math.floor(base * 0.1 + (Math.random() * variance - variance / 2)),
    ),
  }))
}

export const mockDashboardData = {
  kpis: {
    syncedToday: 14728,
    syncedDelta: 12.4,
    skipped: 312,
    noMatch: 87,
    failed: 23,
    activeJobs: 7,
    latency: 142,
  },
  throughput: generateTimeSeriesData(60, 45, 15),
  latency: generateTimeSeriesData(60, 120, 40),
  recentFailures: [
    {
      id: 'evt_8f72a',
      phone: '+1 (555) 234-5678',
      source: 'bonzo',
      target: 'ghl',
      reason: '429 Rate limit exceeded',
      time: '2m ago',
    },
    {
      id: 'evt_9b31c',
      phone: '+1 (555) 876-5432',
      source: 'ghl',
      target: 'five9',
      reason: 'Invalid phone format',
      time: '14m ago',
    },
    {
      id: 'evt_2c44d',
      phone: '+1 (555) 111-2222',
      source: 'salesforce',
      target: 'bonzo',
      reason: 'Contact not found in GHL',
      time: '1h ago',
    },
    {
      id: 'evt_5e11f',
      phone: '+1 (555) 333-4444',
      source: 'five9',
      target: 'salesforce',
      reason: 'Auth token expired',
      time: '2h ago',
    },
    {
      id: 'evt_7a99b',
      phone: '+1 (555) 999-8888',
      source: 'bonzo',
      target: 'ghl',
      reason: 'Loop guard prevented sync',
      time: '3h ago',
    },
  ],
  failureReasons: [
    { reason: 'Invalid phone format', percentage: 38, count: 45 },
    { reason: 'Bonzo 429 rate limit', percentage: 24, count: 28 },
    { reason: 'GHL contact not found', percentage: 18, count: 21 },
    { reason: 'Loop guard triggered', percentage: 12, count: 14 },
    { reason: 'Other', percentage: 8, count: 9 },
  ],
}

const firstNames = [
  'James',
  'Mary',
  'John',
  'Patricia',
  'Robert',
  'Jennifer',
  'Michael',
  'Linda',
  'William',
  'Elizabeth',
]
const lastNames = [
  'Smith',
  'Johnson',
  'Williams',
  'Brown',
  'Jones',
  'Garcia',
  'Miller',
  'Davis',
  'Rodriguez',
  'Martinez',
]

export const mockProspects = Array.from({ length: 30 }).map((_, i) => ({
  id: `prospect_${10000 + i}`,
  firstName: firstNames[i % firstNames.length],
  lastName: lastNames[(i * 3) % lastNames.length],
  email: `${firstNames[i % firstNames.length].toLowerCase()}.${lastNames[(i * 3) % lastNames.length].toLowerCase()}@example.com`,
  phone: `+1 (555) ${Math.floor(100 + Math.random() * 900)}-${Math.floor(1000 + Math.random() * 9000)}`,
  owner:
    firstNames[(i * 2) % firstNames.length] +
    ' ' +
    lastNames[(i * 4) % lastNames.length],
  tags: ['VIP', 'Refi', 'Inbound', 'Cold', 'Warm']
    .sort(() => 0.5 - Math.random())
    .slice(0, Math.floor(Math.random() * 3) + 1),
  stage: [
    'New Lead',
    'Attempted Contact',
    'Connected',
    'Application',
    'Closed',
  ].sort(() => 0.5 - Math.random())[0],
  lastSync: `${Math.floor(Math.random() * 24)}h ago`,
  dnc: {
    bonzo: Math.random() > 0.7,
    ghl: Math.random() > 0.8,
    five9: Math.random() > 0.6,
  },
}))

export const mockEvents = Array.from({ length: 80 }).map((_, i) => {
  const sources = ['bonzo', 'ghl', 'five9', 'salesforce']
  const source = sources[Math.floor(Math.random() * sources.length)]
  const target = sources.filter((s) => s !== source)[
    Math.floor(Math.random() * 3)
  ]
  const statuses = [
    'synced',
    'synced',
    'synced',
    'skipped',
    'no-match',
    'error',
    'ignored',
  ]
  const status = statuses[Math.floor(Math.random() * statuses.length)]
  const types = ['DNC Set', 'DNC Remove', 'Status Sync', 'Owner Change']

  return {
    id: `evt_${Math.random().toString(36).substr(2, 9)}`,
    timestamp: new Date(Date.now() - Math.random() * 86400000).toISOString(),
    source,
    target,
    type: types[Math.floor(Math.random() * types.length)],
    phone: `+1 (555) ${Math.floor(100 + Math.random() * 900)}-${Math.floor(1000 + Math.random() * 9000)}`,
    prospectId: `prospect_${10000 + Math.floor(Math.random() * 30)}`,
    status,
    duration: Math.floor(Math.random() * 500) + 50,
  }
})
